import React, { useState } from "react"
import { Formik, Form, Field } from "formik"
import Button from "shared/components/Button/Button"
import * as yup from "yup"
import { connect } from "react-redux"
import compose from "ramda/src/compose"
import PropTypes from "prop-types"

import { sendUsageProfileFiles } from "services/state/usage/action"

import { showToast } from "components/Toast"
import FloatLabelInput from "shared/components/ModernFloatLabelInput"
import Typograph from "components/Typograph"
import ButtonLoading from "../ButtonLoading"

import styles from "./styles.css"

const schema = yup.object().shape({
  email: yup.string().email("Email inválido").required("Campo obrigatório")
})

const SendForm = ({
  onClose,
  customer,
  productSelected,
  sendUsageProfileFiles
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = (payload) => {
    setIsSubmitting(true)
    sendUsageProfileFiles(
      {
        productKey: productSelected.assetTag,
        email: payload.email
      },
      customer.data
    )
      .then(() => {
        showToast({
          message:
            "Cliente, o seu histórico de consumo foi enviado para o e-mail com sucesso!",
          type: "sucess"
        })
      })
      .catch(() => {
        showToast({
          message:
            "Cliente, ocorreu um erro ao tentar enviar seu histórico de consumo por e-mail ! Tente novamente dentro de alguns minutos.",
          type: "error"
        })
      })
      .finally(() => {
        setIsSubmitting(false)
        onClose()
      })
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{ email: "" }}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ errors }) => (
        <Form>
          <Typograph htmlTag="h3" preset="h2">
            Enviar por e-mail
          </Typograph>

          <div className={styles.input}>
            <Field
              type="text"
              name="email"
              as={FloatLabelInput}
              placeholder="Digite seu e-mail"
              error={errors.email}
            />
          </div>

          <div className={styles.btnGroup}>
            <Button
              type="button"
              buttonStyle="secondary"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancelar
            </Button>

            <ButtonLoading
              type="submit"
              buttonStyle="primary"
              isLoading={isSubmitting}
            >
              Enviar
            </ButtonLoading>
          </div>
        </Form>
      )}
    </Formik>
  )
}

SendForm.propTypes = {
  onClose: PropTypes.func,
  customer: PropTypes.shape({
    data: PropTypes.any
  }),
  productSelected: PropTypes.shape({
    assetTag: PropTypes.string
  }),
  sendUsageProfileFiles: PropTypes.func
}

SendForm.defaultProps = {
  onClose: () => {},
  customer: { data: null },
  productSelected: { assetTag: "" },
  sendUsageProfileFiles: () => Promise.resolve()
}

const mapStateToProps = ({ customer }) => ({ customer })

const enhance = compose(
  connect(mapStateToProps, {
    sendUsageProfileFiles
  })
)

export default enhance(SendForm)



// WEBPACK FOOTER //
// ./src/scenes/ConsumptionProfile/components/SendForm/index.js